<template>
    <div>
        <PCDetail 
            v-if="getInfor && isMobile === false" 
            :infor="infor" 
             :key="id"
        />
        <MobDetail 
            v-else-if="getInfor && isMobile" 
            :infor="infor"
             :key="id"
        />
    </div>
</template>
<script>

    import PCDetail from '@/components/pc/PCDetail'
    import MobDetail from '@/components/mobile/MobDetail'

    import jquery from 'jquery'

    jquery.ajaxSetup({
        cache : false
    });

    export default {
        name: 'Detail',
        props: {
            id: String,
            isMobile: Boolean
        },
        components: {
            PCDetail,
            MobDetail
        },
        data () {
            return {
                infor: {},
                getInfor: false
            }
        },
        mounted () {
            // console.log(this.$route.path);
            // console.log(this.$route.params);
            // console.log(this.$route.query);
            // console.log(jquery);
            this.infor = {};
            this.getInfor = false;
            // jquery 获取数据
            let _this = this;
            let id = this.id;
            window.getAjaxJson = {};
            jquery.get('./json/detail/' + id + '.js', function(){
               _this.infor =  window.getAjaxJson;
               _this.getInfor = true;
            });

            // vue 获取数据
            // this.$http.get('./json/detail/' + id + '.js', {
            
            // }).then((res) => {
            //      console.log(res.data);
            //      var detaliJson;

            //      console.log(detaliJson);

            //     //  let json = res.data;

            //     // console.log(typeof json);
            //     // console.log(JSON.parse(json));

            // }).catch((err) => {
            //     console.log(err);
            // });

        },
        methods: {

        },
        activated() {
            
        },
        deactivated() {
            
        },
        watch: {
            // '$route' (val, oldVal) {
            '$route' () {    
                // jquery 获取数据
                this.infor = {};
                this.getInfor = false;
                let _this = this;
                let id = this.id;
                window.getAjaxJson = {};
                jquery.get('./json/detail/' + id + '.js', function(){
                   _this.infor =  window.getAjaxJson;
                   _this.getInfor = true;
                }); 
                // console.log(val);
                // console.log(oldVal);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>